import api from './api';

export function postReferences(data) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/create-references`, data);
}

export function getReferences(idcredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/references/${idcredit}`);
}
